import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";

import { useDispatch } from "react-redux";

import { employeFlowActions } from "@store/actions";

import { TabContent, TabPane } from "reactstrap";

import { ContainerFluid } from "@components/TransitionFluid";
import BaseContent from "@pages/layouts/container/BaseContent";
import { getSpecificsEnterpriseSections, permissionEnterpriseTabs } from "@pages/layouts/utils/Permissions.lists";

import ContainerAnniversary from "./anniversary";
import ContainerBeginEnd from "./beginEnd";
import LoadProtocol from "./beginEnd/LoadProtocol/index";
import ExportList from "./exportation";
import ImportList from "./importation";
import Indisponibility from "./indisponibility";
import ContainerListEmployers from "./list";
import ContainerStatistique from "./statistic";
import SuiviDisciplinary from "./suivisDisciplinary"
import BulkEditList from "./bulkEdit";

export default function Index({ isAllowedTabs }) {
  const reduxDispatch = useDispatch();

  const [activeTab, setActiveTabState] = useState("listBuild");
  const [activeImport, setActiveImport] = useState(false);
  const [activeExport, setActiveExport] = useState(false);
  const [activeBulkEdit, setActiveBulkEdit] = useState(false);
  const [showLoadProtocol, setShowLoadProtocol] = useState(false);
  const [showList, setShowList] = useState(false);
  const availableTabs = useRef(permissionEnterpriseTabs["employees"]);

  const removeStorage = () => {
    localStorage.removeItem("state-add-infopers");
    localStorage.removeItem("store-infopers-add");
    localStorage.removeItem("state-emploi&salary");
  };

  useEffect(() => {
    return () => {
      removeStorage();
    };
  }, []);

  const importList = useCallback(() => {
    setActiveImport((_activeImport) => !_activeImport);
  }, []);

  const toggleLoadProtocol = useCallback(() => {
    setShowLoadProtocol(true);
    setShowList(false);
  }, []);

  const exportList = useCallback(() => {
    setActiveExport((_activeExport) => !_activeExport);
  }, []);

  const returnToList = useCallback(() => {
    setShowLoadProtocol(false);
    setShowList(true);
    reduxDispatch(employeFlowActions.loadData);
  }, []);

  const toGoToFile = () => {
    reduxDispatch({
      type: "SET_CURRENT_TAB",
      payload: "DListEmploisalary"
    });
  };

  const employeesAvailableSections = useMemo(() => {
    const tabs = [
      "statistiquesBuild",
      "beginEnd"
    ];
  
    const availableTabs = tabs.filter(isAllowedTabs);
  
    return availableTabs.length > 0 ? getSpecificsEnterpriseSections(availableTabs)?.filter(isAllowedTabs) : [];
  }, [isAllowedTabs, getSpecificsEnterpriseSections]);

  const bulkEditList = useCallback(() => {
    setActiveBulkEdit((prev) => !prev);
  }, []);
  
 
  return (
    <BaseContent
      availableTabs={availableTabs?.current}
      setActiveTab={setActiveTabState}
      activeTab={activeTab}
      classColorSelection="arh-tab-green"
      withTab={true}
    >
      <ContainerFluid trigger={activeTab}>
        <TabContent activeTab={activeTab}>
          {isAllowedTabs("listBuild") && (
            <TabPane tabId="listBuild">
              {activeImport ? (
                <ImportList returnToEmployeList={importList} />
              ) : activeExport ? (
                <ExportList returnToEmployeList={exportList} />
              ) : activeBulkEdit ? (
                <BulkEditList returnToEmployeList={bulkEditList} />
              ) : (
                <ContainerListEmployers
                  importList={importList}
                  exportList={exportList}
                  bulkEditList={bulkEditList}
                />
              )}
            </TabPane>
          )}

          {isAllowedTabs("statistiquesBuild") && (
            <TabPane tabId="statistiquesBuild">
              <div>
                <ContainerStatistique 
                  avalaibleSections={employeesAvailableSections?.filter((item)=>item.includes("statistiquesBuild"))}
                />
              </div>
            </TabPane>
          )}

          {isAllowedTabs("anniversaryBuild") && (
            <TabPane tabId="anniversaryBuild">
              <ContainerAnniversary />
            </TabPane>
          )}
          {isAllowedTabs("beginEnd") && (
            <TabPane
              tabId="beginEnd"
              className="container_beginEnd"
            >
              {showLoadProtocol ? (
                <LoadProtocol onBackClicked={returnToList} />
              ) : (
                <ContainerBeginEnd
                  showList={showList}
                  toggleLoadProtocol={toggleLoadProtocol}
                  avalaibleSections={employeesAvailableSections?.filter((item)=>item.includes("beginEnd"))}
                />
              )}
            </TabPane>
          )}
          {isAllowedTabs("indisponibility") && (
            <TabPane tabId="indisponibility">
              <Indisponibility toGoToFile={toGoToFile} />
            </TabPane>
          )}
          {isAllowedTabs("disciplinary") && (
            <TabPane tabId="disciplinary">
                <SuiviDisciplinary />
                
            </TabPane>
          )}
        </TabContent>
      </ContainerFluid>
    </BaseContent>
  );
}
